import { render, staticRenderFns } from "./InvitesPageContainer.vue?vue&type=template&id=5a0f51ec&"
import script from "./InvitesPageContainer.vue?vue&type=script&lang=js&"
export * from "./InvitesPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports